import { Component, OnInit, ViewChild } from '@angular/core';

import { PageAction } from '../../components/page-actions/page-actions.component';
import { Router } from '@angular/router';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { AngieScreensService } from '@services/angie-screens/angie-screens.service';
import { DialogService } from '@services/dialog/dialog.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';

@Component({
    selector: 'app-angie-screens',
    templateUrl: './angie-screens.component.html',
    styleUrls: ['./angie-screens.component.scss'],
    providers: [AngieScreensService],
    standalone: false
})
export class AngieScreensComponent implements OnInit {

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  public title = 'Angie Screens';

  public pageActions: PageAction[];

  public columns = [{ prop: 'name' }, { prop: 'uuid' }, { prop: 'isTouch2015' }];
  public searchColumns = [{ prop: 'name' }];

  constructor(
    public angieScreensService: AngieScreensService,
    private router: Router,
    private dialogService: DialogService,
    private snackbar: SnackbarService
  ) {
  }

  ngOnInit() {
    this.createPageAction();
  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['angie-screens', event.row._id]);
  }

  public onEdit(event: DataTableEvent): void {
    this.router.navigate(['angie-screens', event.row._id, 'edit']);
  }

  public onRemove(event: DataTableEvent): void {
    this.dialogService.confirm('Delete this angie screen, angie-customer, screen-settings and jsons?')
      .then(res => {
        if (!res) {
          return;
        }
        return this.angieScreensService.remove(event.row._id).then(() => {
          this.dataTable.refresh();
          this.snackbar.success('Angie screen removed', 2000);
        }, error => {
          const message = (error.error.message ? error.error.message : error.message);
          console.error(error);
          return this.dialogService.confirm(message, error.name);
        });
      });
  }

  private createPageAction() {
    this.pageActions = [
      new PageAction({
        icon: 'create_new_folder',
        title: 'Create new angie screen',
        callback: () => {
          this.router.navigate(['angie-screens', 'create']);
        }
      })
    ]
  }

}
